// services/ads.service.js

import apiClient from "./apiClient";

const adsEndpoint = "/ads";

export const getAllAds = async () =>
  apiClient.get(adsEndpoint).then((res) => res.data);

export const getAdsByFilter = async (filters) => {
  // 1. Hacemos una copia de los filtros para no romper la UI de React
  const cleanFilters = { ...filters };

  // 2. Limpiamos CUALQUIER campo que envíe arrays de objetos (zone, adStatus, etc.)
  // Esto asegura que solo enviamos los IDs o los valores necesarios.
  if (cleanFilters.zone && Array.isArray(cleanFilters.zone)) {
    cleanFilters.zone = cleanFilters.zone.map((z) =>
      z._id ? { _id: z._id } : z,
    );
  }

  if (cleanFilters.adStatus && Array.isArray(cleanFilters.adStatus)) {
    cleanFilters.adStatus = cleanFilters.adStatus.map((s) => s.name || s);
  }

  if (
    cleanFilters.adBuildingType &&
    Array.isArray(cleanFilters.adBuildingType)
  ) {
    cleanFilters.adBuildingType = cleanFilters.adBuildingType.map(
      (b) => b.name || b,
    );
  }

  // 3. Ahora enviamos cleanFilters, que es mucho más ligero
  return apiClient
    .get(`${adsEndpoint}/filter`, { params: cleanFilters })
    .then((res) => res.data);
};

export const getAdById = async (id) =>
  apiClient.get(`${adsEndpoint}/${id}`).then((res) => res.data);

export const getAllAdsByConsultantId = async (consultantId) =>
  apiClient
    .get(`${adsEndpoint}/consultant/${consultantId}`)
    .then((res) => res.data);

export const getAdsByContact = async (id) =>
  apiClient.get(`${adsEndpoint}/contact/${id}`).then((res) => res.data);

export const getMatchedRequests = (id, searchValue) =>
  apiClient
    .get(`${adsEndpoint}/matching/${id}`, {
      params: { search: searchValue },
    })
    .then((res) => res.data);

export const createAd = async (formData) => {
  // Para POST, el cuerpo de la petición es el segundo argumento
  return apiClient
    .post(`${adsEndpoint}/create`, formData)
    .then((res) => res.data);
};

// --- FUNCIONES DE ACTUALIZACIÓN (PUT) ---

export const updateAd = async (formData) => {
  // Para PUT, el cuerpo de la petición también es el segundo argumento
  return apiClient.put(`${adsEndpoint}/edit`, formData).then((res) => res.data);
};

export const updateAdSendedTo = async (formData) =>
  apiClient
    .put(`${adsEndpoint}/edit/sendedto`, formData)
    .then((res) => res.data);

export const updateManyConsultantsAds = (ads, currentConsultantId) =>
  apiClient
    .put(`${adsEndpoint}/editmanyconsultant/${currentConsultantId}`, ads)
    .then((res) => res.data);

// --- MANEJO DE ARCHIVOS (FormData) ---

export const uploadImage = async (id, formData, from) => {
  // Axios detecta que 'formData' es FormData y ajusta las cabeceras automáticamente
  return apiClient
    .put(`${adsEndpoint}/upload/${from}/${id}`, formData)
    .then((res) => res.data);
};

export const updateImageOrder = async (adId, data) => {
  // El segundo argumento de apiClient.put es el cuerpo de la petición.
  return apiClient
    .put(`${adsEndpoint}/${adId}/images/order`, data)
    .then((res) => res.data);
};

export const deleteImage = async (id, formData, from) =>
  apiClient
    .put(`${adsEndpoint}/delete/${from}/${id}`, formData)
    .then((res) => res.data);

// --- FUNCIONES DE BORRADO (DELETE) ---

export const deleteAd = (id) =>
  apiClient.delete(`${adsEndpoint}/delete/${id}`).then((res) => res.data);
